import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/newsletter-modal-250319.jpg")